import { AgGridConfig } from '@approot/models';
import { Header } from '@approot/models/ag-grid.model';
import { ColumnApi } from 'ag-grid-community';

export function applyColumnState(columnApi: ColumnApi, columnState: any) {
  try {
    columnApi.applyColumnState({
      state: columnState,
      applyOrder: true
    });
  } catch (e) {
    console.error('Unable to load column state');
  }
}

export function mapHeaders(setting: AgGridConfig, globalDef: AgGridConfig) {
  const defaultHeaders = globalDef.headers as Header[];
  const settingHeaders = setting.headers as string[];
  return settingHeaders.map(headerName => {
    return defaultHeaders.find(header => header.field === headerName);
  });
}
